/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Request_AccessInputs */

const en_request_access = /** @type {(inputs: Request_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request Access`)
};

const es_request_access = /** @type {(inputs: Request_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar Acceso`)
};

const fr_request_access = /** @type {(inputs: Request_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander l'accès`)
};

const de_request_access = /** @type {(inputs: Request_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugang anfordern`)
};

const id_request_access = /** @type {(inputs: Request_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minta Akses`)
};

/** @type {(inputs: Request_AccessInputs) => LocalizedString} */
const ja_request_access = en_request_access;

/** @type {(inputs: Request_AccessInputs) => LocalizedString} */
const zh_request_access = en_request_access;

/** @type {(inputs: Request_AccessInputs) => LocalizedString} */
const ar_request_access = en_request_access;

/** @type {(inputs: Request_AccessInputs) => LocalizedString} */
const it_request_access = en_request_access;

/** @type {(inputs: Request_AccessInputs) => LocalizedString} */
const ru_request_access = en_request_access;

/** @type {(inputs: Request_AccessInputs) => LocalizedString} */
const pt_request_access = en_request_access;

/** @type {(inputs: Request_AccessInputs) => LocalizedString} */
const ko_request_access = en_request_access;

/**
* | output |
* | --- |
* | "Request Access" |
*
* @param {Request_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const request_access = /** @type {((inputs?: Request_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Request_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_request_access(inputs)
	if (locale === "es") return es_request_access(inputs)
	if (locale === "fr") return fr_request_access(inputs)
	if (locale === "de") return de_request_access(inputs)
	if (locale === "ja") return ja_request_access(inputs)
	if (locale === "zh") return zh_request_access(inputs)
	if (locale === "ar") return ar_request_access(inputs)
	if (locale === "id") return id_request_access(inputs)
	if (locale === "it") return it_request_access(inputs)
	if (locale === "ru") return ru_request_access(inputs)
	if (locale === "pt") return pt_request_access(inputs)
	return ko_request_access(inputs)
});